// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-module__spinner___2quu9","spin":"Spinner-module__spin___1NQvo"};